import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BRAND_GREEN, BRAND_GOLD } from '../../theme/sucronTheme';
import { useGovernanceLang } from '../../contexts/GovernanceLangContext';

const usePrefix = () => {
  const { pathname } = useLocation();
  return pathname.startsWith('/governance') ? '/governance' : '';
};

const HUB_LABELS = {
  pt: {
    pageTitle: 'Content Hub',
    pageSubtitle: 'Ferramentas de conteúdo e analytics (acesso restrito à governança).',
    open: 'Abrir →',
    new: 'NOVO', pilot: 'PILOTO',
    cards: [
      { title: 'Editorial Engine',  description: 'Pipeline editorial completo: insights → drafts → publicação de estudos.', badge: 'new' },
      { title: 'Creator Studio',    description: 'Gerar posts, narrativas editoriais e conteúdo de rede social.', badge: null },
      { title: 'Study Builder',     description: 'Construtor de estudos interativo: escolha competição, ano, prova e monte gráficos.', badge: 'new' },
      { title: 'Analytics Tool',    description: 'Dashboards internos, métricas de produto e monitoramento.', badge: null },
      { title: 'Piloto: 100m Borboleta Feminino — Maria Lenk', description: 'Estudo automático com dados reais (2024–2026). Preview editável.', badge: 'pilot' },
    ],
  },
  en: {
    pageTitle: 'Content Hub',
    pageSubtitle: 'Content and analytics tools (restricted governance access).',
    open: 'Open →',
    new: 'NEW', pilot: 'PILOT',
    cards: [
      { title: 'Editorial Engine',  description: 'Full editorial pipeline: insights → drafts → publishing studies.', badge: 'new' },
      { title: 'Creator Studio',    description: 'Generate posts, editorial narratives and social network content.', badge: null },
      { title: 'Study Builder',     description: 'Interactive study builder: choose competition, year, event and build charts.', badge: 'new' },
      { title: 'Analytics Tool',    description: 'Internal dashboards, product metrics and monitoring.', badge: null },
      { title: 'Pilot: 100m Butterfly Women — Maria Lenk', description: 'Automated study with real data (2024–2026). Editable preview.', badge: 'pilot' },
    ],
  },
};

const CARD_PATHS = (prefix) => [
  `${prefix}/content/editorial-engine`,
  `${prefix}/content/creator`,
  `${prefix}/content/study-builder`,
  `${prefix}/content/analytics-tool`,
  `${prefix}/content-studio`,
];

const GovernanceContentHubPage = () => {
  const prefix = usePrefix();
  const { lang } = useGovernanceLang();
  const t = HUB_LABELS[lang] || HUB_LABELS.pt;
  const paths = CARD_PATHS(prefix);

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <img src="/vukz-logo.png" alt="Vukz" className="w-11 h-11 rounded-xl object-contain bg-gray-50 border border-gray-200 p-0.5" onError={(e) => { e.target.style.display = 'none'; }} />
        <div>
          <h1 className="text-gray-900 text-2xl font-extrabold">{t.pageTitle}</h1>
          <p className="text-gray-500 mt-1">{t.pageSubtitle}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {t.cards.map((c, i) => {
          const badgeText = c.badge === 'new' ? t.new : c.badge === 'pilot' ? t.pilot : null;
          return (
            <Link key={paths[i]} to={paths[i]}
              className="block bg-white rounded-xl border border-gray-200 p-6 hover:shadow-md transition-all duration-200">
              <div className="flex items-center gap-2">
                <h2 className="text-lg font-bold" style={{ color: BRAND_GREEN }}>{c.title}</h2>
                {badgeText && (
                  <span className="px-1.5 py-0.5 text-[10px] font-bold rounded" style={{ backgroundColor: BRAND_GOLD, color: '#ffffff' }}>
                    {badgeText}
                  </span>
                )}
              </div>
              <p className="text-sm text-gray-500 mt-2">{c.description}</p>
              <span className="inline-block mt-4 text-sm font-semibold" style={{ color: BRAND_GOLD }}>{t.open}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default GovernanceContentHubPage;
